import { createFileRoute } from '@tanstack/react-router'
import { BroadcastModeRedirect } from '@/features/chat'

function BroadcastDetailRoute() {
  const { broadcastId } = Route.useParams()
  return <BroadcastModeRedirect mode="detail" broadcastId={Number(broadcastId)} />
}

export const Route = createFileRoute('/chat/broadcasts/$broadcastId')({
  component: BroadcastDetailRoute,
  staticData: { authorize: true },
})
